export const actionTypes = {
  GET_PRODUCTS_GROUP: "GET_PRODUCTS_GROUP",
  SET_PRODUCTS_GROUP: "SET_PRODUCTS_GROUP",
  GET_PRODUCTS_GROUP_ID: "GET_PRODUCTS_GROUP_ID",
  SET_PRODUCTS_GROUP_ID: "SET_PRODUCTS_GROUP_ID",
  EDIT_FORM_CHANGE: "EDIT_FORM_CHANGE",
  CREATE_PRODUCT_GROUP: "CREATE_PRODUCT_GROUP",
  UPDATE_PRODUCT_GROUP: "UPDATE_PRODUCT_GROUP",
  SET_UPDATED_PRODUCT_GROUP: "SET_UPDATED_PRODUCT_GROUP",
  GET_FILTERED_RESULTS: "GET_FILTERED_RESULTS",
  SET_FILTERED_RESULTS: "SET_FILTERED_RESULTS",
};

export const actions = {
  getProductsGroup: (payload) => ({
    type: actionTypes.GET_PRODUCTS_GROUP,
    payload: payload,
  }),

  setProductsGroup: (payload) => ({
    type: actionTypes.SET_PRODUCTS_GROUP,
    payload: payload,
  }),

  getProductsGroupById: (payload) => ({
    type: actionTypes.GET_PRODUCTS_GROUP_ID,
    payload: payload,
  }),

  setProductsGroupById: (payload) => ({
    type: actionTypes.SET_PRODUCTS_GROUP_ID,
    payload: payload,
  }),

  setEditForm: (payload) => ({
    type: actionTypes.EDIT_FORM_CHANGE,
    payload: payload,
  }),

  createProductGroup: (payload) => ({
    type: actionTypes.CREATE_PRODUCT_GROUP,
    payload: payload,
  }),

  updateProductGroup: (payload) => ({
    type: actionTypes.UPDATE_PRODUCT_GROUP,
    payload: payload,
  }),

  setUpdatedProductGroup: (payload) => ({
    type: actionTypes.SET_UPDATED_PRODUCT_GROUP,
    payload: payload,
  }),

  getFilteredResults: (payload) => ({
    type: actionTypes.GET_FILTERED_RESULTS,
    payload: payload,
  }),

  setFilteredResults: (payload) => ({
    type: actionTypes.SET_FILTERED_RESULTS,
    payload: payload,
  }),
};
